import { useNavState } from '@/providers/NavStateProvider';
import { useEffect, useState } from 'react';
import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { Link } from 'react-router-dom';
import { useWorkspaceUsers } from '@/hooks/api/0150_workspace_users';
import { UserInvitationsElement } from '@/features/w/[identifier]/setting/members/{components}/UserInvitationsElement';
import { InvalidityStateBadge } from '@/features/w/[identifier]/setting/members/{components}/InvalidityStateBadge';
import { AdminBadge } from '@/features/w/[identifier]/setting/members/{components}/AdminBadge';

export const WorkspaceMembers = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('スペースユーザー設定'), []);
  useEffect(() => setBreadcrumbs([]), []);

  const { setShowLoading } = useLoading();
  const { _w_, me } = useCurrentWorkspace();

  return (
    <WorkspaceLayout>
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'member'} />

        <div className="row">
          <div className="col-12 col-lg-9 mx-auto">
            <MembersElement />
            <UserInvitationsElement />
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};

const MembersElement = () => {
  const { _w_, me } = useCurrentWorkspace();
  const { data } = useWorkspaceUsers({ identifier: _w_!.identifier, include_invalidity: true });

  return (
    <div className="card mb-4">
      <div className="card-header d-flex align-items-center">
        <div className="col-md-8">
          <h5 className="mb-0">ユーザー一覧</h5>
        </div>
        <div className="col-md-4 d-flex justify-content-end">
          {me!.admin && (
            <Link
              to={`/w/${_w_!.identifier}/setting/members/new_invitation`}
              className="btn bg-gradient-primary btn-icon"
            >
              <i className="fas fa-plus"></i>ユーザーの招待
            </Link>
          )}
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="table-responsive">
          <table className="table align-items-center">
            <thead>
              <tr>
                <th
                  className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  style={{ width: 62 }}
                >
                  ステータス
                </th>
                <th
                  className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  style={{ width: 300 }}
                >
                  ユーザー名
                </th>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  メールアドレス
                </th>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">権限</th>
                <th className="text-secondary opacity-7" style={{ width: 55 }}></th>
              </tr>
            </thead>
            <tbody>
              {data != null &&
                data.map((u) => (
                  <tr key={`user-${u.id}`}>
                    <td className="text-sm">
                      <InvalidityStateBadge invalidity={u.invalidity} />
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <img src={u.user_account.icon_file_url} className="avatar avatar-sm me-2" alt="avatar image" />
                        <h6 className="mb-0 text-sm">{u.user_account.name}</h6>
                      </div>
                    </td>
                    <td className="text-xs">{u.user_account.email}</td>
                    <td className="text-sm">
                      <AdminBadge admin={u.admin} />
                    </td>
                    <td>
                      {me!.admin && me!.id != u.id && (
                        <Link
                          to={`/w/${_w_!.identifier}/setting/members/${u.id}/edit`}
                          className="btn btn-icon-only btn-outline-success"
                        >
                          <i className="fas fa-edit text-success text-sm"></i>
                        </Link>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
